import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect } from 'react';
import {
  getTermReportConfigsErrorSelector,
  termReportConfigsSelector,
} from '../actions/selectors';
import { getTermReportConfigs } from '../actions';
import useApiLoading from './useApiLoading';
import { GET_TERM_REPORT_CONFIGS_REQUEST } from '../actions/types';

const useTermReportsConfig = () => {
  const dispatch = useDispatch();
  const termReportConfigs = useSelector(termReportConfigsSelector);
  const getTermReportConfigsError = useSelector(
    getTermReportConfigsErrorSelector
  );
  const { isRequestPending: isGetTermReportsConfigLoading } = useApiLoading(
    GET_TERM_REPORT_CONFIGS_REQUEST
  );
  const handleGetTermReportConfigs = useCallback(() => {
    dispatch(getTermReportConfigs.request());
  }, [dispatch]);

  useEffect(() => {
    if (!termReportConfigs?.length && !getTermReportConfigsError) {
      handleGetTermReportConfigs();
    }
  }, []);

  return {
    termReportConfigs,
    handleGetTermReportConfigs,
    isGetTermReportsConfigLoading,
    getTermReportConfigsError,
  };
};

export default useTermReportsConfig;
